var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnpaid = function SvgUnpaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.834 9.167c0 .646.5 1.166 1.113 1.166h1.254c.533 0 .966-.453.966-1.02 0-.606-.266-.826-.66-.966l-2.006-.7c-.394-.14-.66-.354-.66-.967 0-.56.433-1.02.966-1.02h1.254c.613 0 1.113.52 1.113 1.167M8.5 5v6",
    stroke: "#FBFCFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.167 8a6.669 6.669 0 0 1-6.666 6.667A6.669 6.669 0 0 1 1.834 8a6.67 6.67 0 0 1 6.667-6.667",
    stroke: "#FBFCFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.834 1.333 3.333 3.334M15.166 1.333l-3.3 3.3",
    stroke: "#FBFCFF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};

export { SvgUnpaid as ReactComponent };
export default __webpack_public_path__ + "static/media/unpaid.f41f4dac.svg";